import React, { useState } from "react";
import { Spinner, Button } from '../../ui/components';
export default function MissingDir({ path, onClose }) {
    const [creating, setCreating] = useState(false);
    const create = () => {
        setCreating(true);
        onClose(true);
    };
    return React.createElement("div", { className: "fill-center" }, creating ?
        React.createElement(Spinner, { radius: "2em" }) :
        React.createElement("div", { className: "center" },
            React.createElement("div", { className: 'icon' }, "folder_off"),
            React.createElement("p", null,
                "Folder ",
                React.createElement("b", null, path),
                " doesn't exist."),
            React.createElement("p", null, "Do you want to"),
            React.createElement("p", null,
                React.createElement(Button, { onClick: () => create(), primary: true }, "Create Folder")),
            React.createElement("p", null,
                React.createElement("span", { className: 'link', onClick: () => onClose(false) }, "turn off synchronized browsing"))));
}
